import React from 'react';

interface PillButtonProps {
  label: string;
  isSelected?: boolean;
  onClick: () => void;
  className?: string;
}

const PillButton: React.FC<PillButtonProps> = ({ 
  label, 
  isSelected = false, 
  onClick,
  className = ''
}) => {
  return (
    <button
      className={`p-2 text-sm whitespace-nowrap px-4 rounded-full border border-[var(--color-blue)] ${
        isSelected
          ? "border-2 font-semibold text-[var(--color-blue)]"
          : "text-black border-[var(--color-grey-light)]"
      } ${className}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
} 

export default PillButton;